import { Directive, Input, TemplateRef } from '@angular/core';

import { generateUuid } from '@recruitee/utils';

import { SelectController } from '../select-controller.service';

@Directive({
  standalone: true,
  selector: '[rtSelectHeaderTemplate]',
})
export class Select2HeaderTemplateDirective {
  @Input() public rtSelectHeaderTemplate: number;

  private readonly uuid = generateUuid();

  constructor(
    private templateRef: TemplateRef<void>,
    private selectController: SelectController,
  ) {}

  public ngOnInit() {
    this.selectController.headerTemplateRegister({
      id: this.uuid,
      index: this.rtSelectHeaderTemplate,
      template: this.templateRef,
    });
  }

  public ngOnDestroy() {
    this.selectController.headerTemplateRemove(this.uuid);
  }
}
